export enum LoadingState {
  fullyLoaded = 0,
  partiallyLoaded = 1,
  loading = 2
}
